module.exports = __webpack_public_path__ + "img/b3.eb18619f.png";